// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"logo_ko-KR__2rIva","impressionTrackingContainer":"logo_impressionTrackingContainer__6Zxw4","logo":"logo_logo__I_OEg","logo__image":"logo_logo__image__vnruH"};